// extracted by mini-css-extract-plugin
export default {"section":"paymentInformationHeader-module__section___v99We","name":"paymentInformationHeader-module__name___N5kHq"};